import * as Sentry from '@sentry/nextjs';
import env from '@beam-australia/react-env';

const SENTRY_DSN: string =
  process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN || "https://112e8d1fe5f2410e8b6fa5ec5462ca31@sentry.retoucher.online/19",
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
  environment: env('ENV'),
  debug: false,
  autoSessionTracking: true,
  release: env('VERSION')
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});